<template>
  <div class="upgrade-notice">
    <div class="notice-box">
      <h1>システムがアップグレードされました / System Upgraded / 系统已升级</h1>
      <p>
        新しいサービスをご利用ください：<br>
        Please visit the new platform: <br>
        请访问新平台：
      </p>
      <p class="link">
        <a href="https://www.servebot.ai" target="_blank">https://www.servebot.ai</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>
.upgrade-notice {
  height: 100vh;
    background-color: #000;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.notice-box {
  text-align: center;
    max-width: 800px;
    padding: 30px;
}

.notice-box h1 {
  font-size: 36px;
    margin-bottom: 20px;
    background: linear-gradient(90deg, #e3ffe7, #d9e7ff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.notice-box p {
  font-size: 20px;
    line-height: 1.6;
}

.link a {
      color: #4dc9ff;
    font-size: 22px;
    text-decoration: underline;
}
</style>
